import { atomWithReset } from 'jotai/utils';

import { MedixsReceptionIdentificationModalState } from './types';

export const medixsReceptionIdentificationModalState =
  atomWithReset<MedixsReceptionIdentificationModalState>({
    isOpen: false,
    error: null,
    patientId: null,
    appointmentId: null,
    medixsSettingId: null,
    selectedMedixsReception: null,
    selectedDate: new Date(),
  });
